var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyPackagesFriendPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 122,
    viewBox: "0 0 123 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 122,
    height: 122,
    rx: 61,
    fill: "url(#paint0_linear_4136_297945)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7104 51.3838H45.4473M93.6052 57.7085V64.3222C93.6052 66.088 92.1925 67.5327 90.3946 67.5969H84.102C80.6346 67.5969 77.4562 65.0606 77.1673 61.5933C76.9746 59.5706 77.7452 57.6764 79.0936 56.3601C80.2815 55.1401 81.9188 54.4338 83.7167 54.4338H90.3946C92.1925 54.498 93.6052 55.9427 93.6052 57.7085Z",
    stroke: "#0061AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0935 56.3608C77.7451 57.6771 76.9745 59.5713 77.1672 61.5939C77.4561 65.0613 80.6345 67.5976 84.1019 67.5976H90.3945V72.2529C90.3945 81.8845 83.9735 88.3055 74.3419 88.3055H45.4472C35.8156 88.3055 29.3945 81.8845 29.3945 72.2529V49.7792C29.3945 41.0466 34.6598 34.9466 42.8466 33.9192C43.6814 33.7908 44.5482 33.7266 45.4472 33.7266H74.3419C75.1766 33.7266 75.9793 33.7587 76.7498 33.8871C85.033 34.8502 90.3945 40.9824 90.3945 49.7792V54.4345H83.7166C81.9187 54.4345 80.2814 55.1408 79.0935 56.3608Z",
    stroke: "#0061AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4136_297945",
    x1: 61.5,
    y1: 0,
    x2: 61.5,
    y2: 122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPackagesFriendPayment);
export default __webpack_public_path__ + "static/media/empty-packages_friend-payment.f34f216394a281667919180ee4fb7b88.svg";
export { ForwardRef as ReactComponent };